import 'babel-polyfill';

import $ from 'jquery';
window.$ = $;

import 'jquery-ui';
import 'angular';
import 'angular-animate';
import 'angular-aria';
import 'angular-dynamic-locale';
import 'angular-loader';
import 'angular-messages';
import 'angular-cookies';
import 'angular-resource';
import 'angular-sanitize';
import 'angular-touch';
import 'angular-ui-bootstrap';

import moment from 'moment-timezone';
import {extendMoment} from 'moment-range';

extendMoment(moment);
window.moment = moment;

import 'angular-ui-router';
import 'accounting';
import 'exports-loader?TrNgGrid!tr-ng-grid';
import 'angular-recaptcha';
import 'angular-translate';
import 'angular-translate-storage-cookie';
import 'angular-translate-storage-local';
import 'angular-translate-loader-partial';
import 'angular-translate-interpolation-messageformat';
import 'angular-simple-logger';
import 'angular-schema-form';
import 'angular-schema-form-bootstrap';
import 'angular-cache';
import 'spectrum-colorpicker';
import 'angular-spectrum-colorpicker';
import 'underscore';
import 'sprintf';
import 'angular-rangeslider';
import 'angular-filter';
import 'es5-shim';
import 'es6-shim';
import 'webshim';
import 'uri-templates';
import 'ng-file-upload';
import 'pusher-js';
import 'pusher-angular';
import 'bootstrap-sass';
import 'ng-a11y/dist/nga11yannounce.min';
import 'ng-a11y/dist/nga11yfocus.min';
import 'ng-a11y/dist/nga11yforms.min';
import 'ng-a11y/dist/nga11ymodal.min';
import 'angular-ui-utils/modules/alias/alias';
import 'angular-ui-utils/modules/event/event';
import 'angular-ui-utils/modules/format/format';
import 'angular-ui-utils/modules/highlight/highlight';
import 'angular-ui-utils/modules/ie-shiv/ie-shiv';
import 'angular-ui-utils/modules/include/include';
import 'angular-ui-utils/modules/indeterminate/indeterminate';
import 'angular-ui-utils/modules/inflector/inflector';
import 'angular-ui-utils/modules/jq/jq';
import 'angular-ui-utils/modules/keypress/keypress';
import 'angular-ui-utils/modules/mask/mask';
import 'angular-ui-utils/modules/reset/reset';
import 'angular-ui-utils/modules/route/route';
import 'angular-ui-utils/modules/scroll/scroll';
import 'angular-ui-utils/modules/scrollfix/scrollfix';
import 'angular-ui-utils/modules/showhide/showhide';
import 'angular-ui-utils/modules/unique/unique';
import 'angular-ui-utils/modules/validate/validate';
import 'angular-ui-utils/modules/utils';
import 'angular-carousel';
import 'ui-select';
import 'angular-google-maps';


// WEBPACK FOOTER //
// node_modules/bookingbug-angular/src/core/main.vendors.js